export default {
  default: () => import("/workspace/src/layouts/default.vue").then(m => m.default || m)
}